var map = {
	"./1 Despacito.mp3": 3561,
	"./2 Night-Changes.mp3": 1264,
	"./3 Senorita-Shawn-Mendes.mp3": 9640,
	"./4 Everything At Once - Lenka.mp3": 5932,
	"./5 Levitating.mp3": 879,
	"./6 Shape-of-You.mp3": 6224,
	"./7 Ignite---Alan-Walker.mp3": 6610,
	"./8 Cheap-Thrills.mp3": 652,
	"./9 Dusk-Till-Dawn.mp3": 2262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6032;